import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { gdprCookiePopupModule } from './store'
import { StorageManager } from '@vue-storefront/core/lib/storage-manager'

export const KEY = 'gdpr-cookie-popup'
export const STORAGE = 'gdpr'
export const MODAL_NAME = 'modal-gdpr-setup-popup'
export const COOKIE_DATA_GETTER = `${KEY}/getCookieData`

/**
 * @param {Object} context
 * @return {void}
 */
export const GdprCookiePopup: StorefrontModule = function ({ app, store }) {
  StorageManager.init(STORAGE)
  store.registerModule(KEY, gdprCookiePopupModule)
}
